<div class="formula-horizontal" flipAnimate  [ngClass]="{ 'formula-budget-page': isOnBudgetPage }">
  <ng-container *ngFor="let item of selectedItems; let last = last">
    <div class="formula-item fade"
         [ngClass]="{ 'highlight': isHighlightOperand(item) }">
      <div *ngFor="let word of item.split(' ')">
        {{ word }}
      </div>
    </div>
    <div *ngIf="!last" class="dash highlight fade">-</div>
  </ng-container>

  <div class="dash highlight fade">=</div>

  <div class="formula-item fade"
       [ngClass]="{ 'bold-highlight': highlightAllOperands }">
    <div *ngFor="let word of availableBudgetFormulaItems">
      {{ word }}
    </div>
  </div>
</div>
